export default "__VITE_ASSET__CtrsrdcK__"